import type { ViewMode } from "../../types";
import { Button } from "@/shared/ui/button";
import { Tooltip } from "@/shared/ui/tooltip";
import { Grid3x3, LayoutGrid, List } from "lucide-react";
import { cn } from "@/shared/lib/cn";

interface ViewModeSwitcherProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}

const viewModes: Array<{
  mode: ViewMode;
  icon: typeof Grid3x3;
  label: string;
}> = [
  { mode: "large-gallery", icon: LayoutGrid, label: "Large gallery view" },
  { mode: "gallery", icon: Grid3x3, label: "Gallery view" },
  { mode: "table", icon: List, label: "Table view" },
];

export function ViewModeSwitcher({
  viewMode,
  onViewModeChange,
}: ViewModeSwitcherProps) {
  return (
    <div className="flex items-center gap-1 rounded-lg border border-grid-200 bg-white p-1">
      {viewModes.map(({ mode, icon: Icon, label }) => (
        <Tooltip key={mode} content={label} side="bottom">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onViewModeChange(mode)}
            className={cn("h-8 w-8", viewMode === mode && "bg-grid-100")}
            aria-label={label}
          >
            <Icon className="h-4 w-4" />
          </Button>
        </Tooltip>
      ))}
    </div>
  );
}
